import Seo from "../components/Seo";
import useContactInfo from "../lib/useContact";

export default function Privacy() {
  const biz = useContactInfo();
  return (
    <div data-testid="privacy-page" className="pt-28 bg-white">
      <Seo
        title="Privacy Policy | Zarco's Decks & Outdoor Living"
        description="How Zarco's Decks & Outdoor Living collects, uses, and protects your information when you request a free estimate."
      />
      <section className="px-6 md:px-12 lg:px-20 py-16 md:py-24 max-w-3xl">
        <p className="text-xs uppercase tracking-[0.3em] text-[#99582A] font-semibold">Legal</p>
        <h1 className="font-display text-4xl md:text-5xl tracking-tight font-medium mt-4 text-[#111]">
          Privacy Policy
        </h1>
        <p className="mt-3 text-sm text-[#666]">Last updated: September 2026</p>

        <div className="mt-10 space-y-8 text-[#4A4A4A] leading-relaxed text-sm md:text-base">
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">What we collect</h2>
            <p className="mt-2">
              When you request an estimate or chat with our website assistant, we collect the
              information you choose to share: your name, phone number, email address, project
              address or city/ZIP, project details, budget and timeline preferences, and any
              photos you upload.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">How we use it</h2>
            <p className="mt-2">
              We use your information only to respond to your request, schedule and prepare your
              free on-site estimate, and communicate with you about your project. We do not sell
              your information, and we do not share it with third parties except the service
              providers that deliver our notifications (for example, our email and SMS providers).
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">Calls & texts</h2>
            <p className="mt-2">
              By submitting the estimate form, you agree that Zarco's Decks & Outdoor Living may
              contact you by phone, text, or email about your request. Message and data rates may
              apply. You can ask us to stop contacting you at any time.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">Analytics</h2>
            <p className="mt-2">
              This website may use privacy-respecting analytics to understand how visitors use the
              site and to improve it. Analytics are only active with cookies-less, aggregate
              measurement and never identify you personally.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">Your choices</h2>
            <p className="mt-2">
              You may request a copy, correction, or deletion of your information at any time by
              contacting us at{" "}
              <a href={biz.emailHref} className="text-[#99582A] underline">{biz.email}</a> or{" "}
              <a href={biz.phoneMainHref} className="text-[#99582A] underline">{biz.phoneMain}</a>.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">Who we are</h2>
            <p className="mt-2">
              Zarco's Decks & Outdoor Living — a family-owned deck and outdoor-living contractor
              serving Rome and select North Georgia / Metro Atlanta communities.
              Website: zarcosdecks.com.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
